import { data } from "jquery";
import { deleteRequest, getRequest, postRequest } from "../config/AxiosConfig";
import API_URLS from "../config/BackendConfig";
import { getAuthToken, getToken } from "../utils/tokenUtils";
import { json } from "zod";

export const RegisterUser = async ({
  formData,
  comapnyGstImage,
  companyCinImage,
  companyPanImage,
  userAadharImage,
  userPanImage,
  userImage,
}) => {
  try {
    const payload = {
      user: {
        name: formData.user.name,
        email_address: formData.user.email_address,
        mobile_number: formData.user.mobile_number,
        password: "password123",

        pin_code: formData.user.pin_code,
        landmark_address: formData.user.landmark_address,
        post_office: formData.user.post_office,
        district: formData.user.district,
        state: formData.user.state,
        dob: formData.user.dob,
        aadhar_number: formData.user.aadhar_number,
        pan_number: formData.user.pan_number,
        pan_image: userPanImage,
        aadhar_image: userAadharImage,
        image: userImage,
      },
      company: {
        company_name: formData.company.company_name,
        company_address: formData.company.company_address,
        company_cin: formData.company.company_cin,
        company_gst_no: formData.company.company_gst_no,
        company_pan: formData.company.company_pan,
        authorized_person_name: formData.company.authorized_person_name,
        company_type_name: formData.company.company_type_name,
        company_cin_photo: companyCinImage,
        company_gst_photo: comapnyGstImage,
        company_pan_photo: companyPanImage,
      },
      payment: {
        user_id: formData.payment.user_id,
        payment_type: formData.payment.payment_type,
        utr: formData.payment.utr,
        amount: formData.payment.amount,
        status_id: "1",
      },
    };
    // console.log(payload)

    const token = getAuthToken();

    const response = await postRequest({
      url: API_URLS.ADMIN + "register/customer",
      data: payload,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const verifyCompanyDetailsService = async (payload) => {
  try {
    const response = await postRequest({
      url: API_URLS.ADMIN + "register/validate-details-step1",
      data: payload,
      headers: { Authorization: `Bearer ${getAuthToken()}` },
    });
    return response;
  } catch (error) {
    return error;
  }
};
export const verifyPersonaDetailsService = async (payload) => {
  try {
    const response = await postRequest({
      url: API_URLS.ADMIN + "register/validate-details-step2",
      data: payload,
      headers: { Authorization: `Bearer ${getAuthToken()}` },
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const GetUserDataByIdService = async ({ userId }) => {
  try {
    const payload = {
      user_id: userId,
    };
    const token = getAuthToken();
    const response = postRequest({
      url: API_URLS.ADMIN + "customer/byuserid",
      data: payload,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const GetUploadedByIdService = async () => {
  try {
    const token = getAuthToken();
    const response = postRequest({
      url: API_URLS.ADMIN + "documents/all",
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const GetUploadedDocumentIdService = async ({ userId }) => {
  try {
    const payload = {
      userid: userId,
    };
    const token = getAuthToken();
    const response = postRequest({
      url: API_URLS.ADMIN + "documents/uploaded",
      data: payload,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (error) {
    return error;
  }
};
export const UploadedDocumentService = async ({ userId, docid, file }) => {
  try {
    const payload = {
      userid: userId,
      docid: docid,
      file: file,
    };

    const token = getAuthToken();
    const response = postRequest({
      url: API_URLS.ADMIN + "documents/upload",
      data: payload,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    return error;
  }
};
export const DeleteDocumentService = async ({ userId, docid }) => {
  try {
    const payload = {
      docid: docid,
      userid: userId,
    };
    const token = getAuthToken();
    const response = postRequest({
      url: API_URLS.ADMIN + "documents/delete",
      data: payload,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    return error;
  }
};
export const ApprovedDocumentService = async ({ userId, docid, remarks }) => {
  try {
    const payload = {
      userid: userId,
      docid: docid,
      remarks: remarks,
    };
    const token = getAuthToken();
    const response = postRequest({
      url: API_URLS.ADMIN + "documents/approve",
      data: payload,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    return error;
  }
};
export const RejectDocumentService = async ({ userId, docid, remarks }) => {
  try {
    const payload = {
      userid: userId,
      docid: docid,
      remarks: remarks,
    };
    const token = getAuthToken();
    const response = postRequest({
      url: API_URLS.ADMIN + "documents/reject",
      data: payload,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    return error;
  }
};
export const PhysicalDocumentService = async ({ userId, status, remarks }) => {
  try {
    const payload = {
      user_id: userId,
      status_id: status,
      remarks: remarks,
    };
    // console.log(payload)
    const token = getAuthToken();
    const response = postRequest({
      url: API_URLS.ADMIN + "user/kyc-status",
      data: payload,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    return error;
  }
};
export const DocumentPreviewService = async (filename) => {
  try {
    const token = getAuthToken();
    const res = await getRequest({
      url: API_URLS.ADMIN + `admin-kyc-files/${filename}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return res;
  } catch (error) {
    return error;
  }
};
export const linkServicePackage = async (payload) => {
  try {
    // console.log(payload)
    const token = getAuthToken();
    const res = await postRequest({
      url: API_URLS.ADMIN + `service-packgae/link`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
      data: payload,
    });
    return res;
  } catch (error) {
    return error;
  }
};

// Api Service Report
export const apiServiceReportService = async (payload, page = 1) => {
  try {
    const token = getAuthToken();
    const res = await postRequest({
      url: API_URLS.ADMIN + `service/preference/report?page=${page}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
      data: payload,
    });
    return res;
  } catch (error) {
    return error;
  }
};

// Fixed Service Methods in apiService.js
export const RegEmployeeService = async (payload) => {
  try {
    const token = getAuthToken();

    const res = await postRequest({
      url: API_URLS.ADMIN + `register/employee`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: payload,
    });
    return res;
  } catch (error) {
    return error?.response || error;
  }
};

// Fixed Services in apiService.js
export const RegEmployeeEdit = async (user_id) => {
  try {
    const token = getAuthToken();

    const res = await postRequest({
      url: API_URLS.ADMIN + `edit/employee`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: { user_id }, // Wrap in object
    });
    return res;
  } catch (error) {
    return error?.response || error;
  }
};

export const RegEmployeeUpdate = async (
  userId,
  payload,
  permissions,
  profilePic,
) => {
  const formData = new FormData();

  // 🔹 user object
  Object.entries(payload).forEach(([key, value]) => {
    formData.append(`user[${key}]`, value ?? "");
  });

  // 🔹 permissions array
  permissions.forEach((perm, index) => {
    formData.append(`permissions[${index}][url]`, perm.url);
    formData.append(`permissions[${index}][status]`, perm.status);
  });

  formData.append("user[image]", profilePic);

  try {
    const token = getAuthToken();

    const res = await postRequest({
      url: API_URLS.ADMIN + `update/employee/${userId}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
      data: formData,
    });
    return res;
  } catch (error) {
    return error?.response || error;
  }
};

// Fixed - Changed from multipart/form-data to application/json
export const RegEmployeeServiceReport = async (payload) => {
  try {
    const token = getAuthToken();
    const res = await postRequest({
      url: API_URLS.ADMIN + `employee/report`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: payload,
    });

    console.log("Service Response:", res); // Debug log

    return res; // Return full response
  } catch (error) {
    console.error("Service Error:", error);
    return error?.response || error;
  }
};

export const CheckEmployeePermissions = async (url) => {
  try {
    const token = getAuthToken();
    const payload = {
      url,
    };

    const res = await postRequest({
      url: API_URLS.ADMIN + `check/permissions`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-type": "application/json",
      },
      data: payload,
    });

    console.log("check permissions response", res);

    return res;
  } catch (error) {
    console.error("Service Error:", error);
    return error?.response || error;
  }
};

export const FetchEmployeePermissions = async (payload) => {
  try {
    const token = getAuthToken();

    const res = await postRequest({
      url: API_URLS.ADMIN + `fetch/employee-permissions`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-type": "application/json",
      },
      data: payload,
    });

    console.log("fetch routes response", res);

    return res;
  } catch (error) {
    console.error("Service Error:", error);
    return error?.response || error;
  }
};
export const FetchAllPermissions = async () => {
  try {
    const token = getAuthToken();

    const res = await postRequest({
      url: API_URLS.ADMIN + `fetch/permissions`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-type": "application/json",
      },
    });

    console.log("fetch routes response", res);

    return res;
  } catch (error) {
    console.error("Service Error:", error);
    return error?.response || error;
  }
};

export const GenerateMerchantToken = async (payload) => {
  try {
    const token = getAuthToken();
    const res = await postRequest({
      url: API_URLS.ADMIN + `auto-debit-r/generate/merchant-token`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        user_id: payload,
      },
    });

    console.log("merchant data Response:", res); // Debug log

    return res; // Return full response
  } catch (error) {
    console.error("Service Error:", error);
    return error?.response || error;
  }
};

export const GetMerchantReport = async (payload) => {
  try {
    const token = getAuthToken();
    const res = await postRequest({
      url: API_URLS.ADMIN + `auto-debit-r/merchant-token/report `,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: payload,
    });

    console.log("merchant Report Response:", res);
    return res;
  } catch (error) {
    console.error("Service Error:", error);
    return error?.response || error;
  }
};

export const createBilling = async (payload) => {
  try {
    const token = getAuthToken();
    const res = await postRequest({
      url: API_URLS.ADMIN + `min-billing/create`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: payload,
    });

    return res;
  } catch (error) {
    console.error("Service Error:", error);
    return error?.response || error;
  }
};

export const updateBilling = async (payload) => {
  try {
    const token = getAuthToken();
    const res = await postRequest({
      url: API_URLS.ADMIN + `min-billing/update`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: payload,
    });

    return res;
  } catch (error) {
    console.error("Service Error:", error);
    return error?.response || error;
  }
};

export const listBilling = async ({ page }) => {
  try {
    const token = getAuthToken();
    const res = await postRequest({
      url: API_URLS.ADMIN + `min-billing/list`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },

      data: {
        total_data: 10,
        page,
      },
    });

    return res;
  } catch (error) {
    console.error("Service Error:", error);
    return error?.response || error;
  }
};

export const viewBilling = async (payload) => {
  try {
    const token = getAuthToken();
    const res = await postRequest({
      url: API_URLS.ADMIN + `min-billing/view`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: payload,
    });

    return res;
  } catch (error) {
    console.error("Service Error:", error);
    return error?.response || error;
  }
};

export const deleteBilling = async (id) => {
  try {
    const token = getAuthToken();
    const res = await deleteRequest({
      url: API_URLS.ADMIN + `min-billing/delete/${id}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return res;
  } catch (error) {
    console.error("Service Error:", error);
    return error?.response || error;
  }
};

export const createIfsc = async (payload) => {
  const token = getAuthToken();
  try {
    const res = await postRequest({
      url: API_URLS.ADMIN + `ifsc/create`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: payload,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const updateIfsc = async (payload) => {
  const token = getAuthToken();
  try {
    const res = await postRequest({
      url: API_URLS.ADMIN + `ifsc/update`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: payload,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const viewIfscDetails = async (payload) => {
  const token = getAuthToken();
  try {
    const res = await postRequest({
      url: API_URLS.ADMIN + `ifsc/view`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-type": "application/json",
      },
      data: payload,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const getIfscList = async (payload) => {
  const token = getAuthToken();

  try {
    const res = await postRequest({
      url: API_URLS.ADMIN + `ifsc/list`,
      headers: {
        Authorization: `Bearer ${token}`,
        "content-type": "application/json",
      },
      data: payload,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const deleteIfsc = async (payload) => {
  const token = getAuthToken();

  try {
    const res = await postRequest({
      url: API_URLS.ADMIN + `ifsc/delete`,
      headers: {
        Authorization: `Bearer ${token}`,
        "content-type": "application/json",
      },
      data: payload,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};


export const fetchAllServices = async (payload) => {
  try {
    const token = getAuthToken();

    const res = await postRequest({
      url: API_URLS.ADMIN + `fetch-services`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: payload,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const fetchPackages = async (payload) => {
  try {
    const token = getAuthToken();

    const res = await postRequest({
      url: API_URLS.ADMIN + `service-packgae/fetch-package`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: payload,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const createQuotation = async (payload) => {
  try {
    const token = getAuthToken();

    const res = await postRequest({
      url: API_URLS.ADMIN + `create-quotation`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: payload,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};
export const updateQuotation = async (payload) => {
  try {
    const token = getAuthToken();

    const res = await postRequest({
      url: API_URLS.ADMIN + `update-quotation`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: payload,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};
export const viewQuotation = async (payload) => {
  try {
    const token = getAuthToken();

    const res = await postRequest({
      url: API_URLS.ADMIN + `view-quotation`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: payload,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};
export const getQuotationByUser = async (payload) => {
  try {
    const token = getAuthToken();

    const res = await postRequest({
      url: API_URLS.ADMIN + `get-quotation-by-user`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: payload,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const getMandateReport = async (payload) => {
  try {
    const token = getAuthToken();

    const res = await postRequest({
      url: API_URLS.ADMIN + `auto-debit-r/mandates`,

      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: payload,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};




